// embedFonts.js — storefront payload preparation (VC-009)
// ============================================================================
// window.StickerEngine.prepareUploadPayload():
//   one chain over ONE generatePayload() result —
//     → generatePayload() once
//     → set root 2×2 inch (viewBox preserved)
//     → assert self-containment (S3-C replacement safety net)
//     → return a NEW payload object (original payload untouched).
//
// VC-011 Stage 3 (S3-B, 2026-08-07): the font chain is REMOVED. Center
// and ring text are glyph outlines (S3-A), so the payload SVGs are pure
// geometry: no text elements, no font data, no font loading API calls
// (WO stage3 §1). Removed: fontsFromState, document.fonts.load/check,
// fontsFromSvg, hasTextElements, fetchFontFiles, bufferToBase64,
// embedFontsInSvg, validateEmbedded (plus their helpers). No network
// request to fonts.googleapis.com can occur on this path anymore.
// validateEmbedded's guarantee is replaced by assertSelfContained
// (S3-C, hard failure naming rule ids).
//
// The file name is kept for compatibility (VC-009 contract); it no
// longer embeds anything.
// ============================================================================

(function () {
  'use strict';

  var eng = window.StickerEngine = window.StickerEngine || {};

  // ── 根 <svg> 尺寸：只改 root 的 width/height，保留 viewBox 与其他属性 ──
  // size 默认 '2in'(打印语义)。OPEN-13 第二糊 v3 (2026-08-08, JJ 裁定)：
  // color-preview 是给 cart 看的非生产件 —— 直接按 200px 生成(cart 显示
  // ≤100px ×2 = 200px),不加文件、无 JPG 白底;production 保持 2in。
  function setSvgPhysicalSize(svgStr, size) {
    size = size || '2in';
    return svgStr.replace(/<svg([^>]*)>/, function (m, attrs) {
      var out = attrs
        .replace(/\swidth\s*=\s*"[^"]*"/, ' width="' + size + '"')
        .replace(/\sheight\s*=\s*"[^"]*"/, ' height="' + size + '"');
      if (!/\swidth\s*=/.test(attrs)) out += ' width="' + size + '"';
      if (!/\sheight\s*=/.test(attrs)) out += ' height="' + size + '"';
      return '<svg' + out + '>';
    });
  }

  // ── 主入口：单 payload 链，fail closed ──
  eng.prepareUploadPayload = async function () {
    var state = eng._getState();
    if (!state) throw new Error('Engine state unavailable');

    // generatePayload() 只调用一次
    var payload = eng.generatePayload();

    // 物理尺寸：color-preview → 200px(OPEN-13 第二糊 v3, JJ 裁定：cart 显示
    // ≤100px ×2;彩色 SVG 非生产件,直接按 200px 生成,不加文件、无 JPG 白底)；
    // production → 2×2 inch 打印语义不变
    var colorSvg = setSvgPhysicalSize(payload.colorPreviewSvg, '200');
    var prodSvg = setSvgPhysicalSize(payload.productionSvg);

    // S3-C replacement safety net (WO stage3 §5.1) — payload must be
    // pure geometry. Hard failure, never degrade (any violation throws
    // with named rule ids).
    eng.assertSelfContained(colorSvg, 'color');
    eng.assertSelfContained(prodSvg, 'production');

    // 新 payload 对象；不改动原 payload 与应用状态
    return {
      sourceFile: payload.sourceFile,
      recipe: payload.recipe,
      colorPreviewSvg: colorSvg,
      productionSvg: prodSvg,
    };
  };
})();
